import type React from 'react';
import {
  Calculator,
  CalendarCheck,
  CalendarDays,
  ChartLine,
  CircleHelp,
  House,
  Search,
} from 'lucide-react';
import { NavLink } from 'react-router';

import logo from 'assets/images/logotype/Logo_Stand_Red.svg';
import { marketingHref, marketingLinks } from 'utils/siteLinks';

import styles from './MobileDrawer.module.scss';
import guest from './GuestMobileNav.module.scss';

// Меню гостя (Figma 18:3826 «Шапка гостя», 360/768 - кнопка «Меню»): те же пункты, что в мобильном
// меню маркетинга, внизу вход и регистрация.
const MARKETING_ITEMS = [
  { href: marketingLinks.home, label: 'Главная', Icon: House },
  { href: marketingHref('/podbor'), label: 'Подбор', Icon: Search },
  { href: marketingHref('/uslugi'), label: 'Цены', Icon: ChartLine },
  { href: marketingHref('/categories/matematika'), label: 'Математика', Icon: Calculator },
  { href: marketingLinks.probniyUrok, label: 'Пробный урок', Icon: CalendarCheck },
  { href: marketingLinks.questions, label: 'Вопросы', Icon: CircleHelp },
  { href: marketingHref('/podgotovka'), label: 'План', Icon: CalendarDays },
];

export const GuestMobileNav: React.FC<{ onNavigate?: () => void }> = ({ onNavigate }) => (
  <>
    <a href={marketingLinks.home} className={styles.drawerLogo} onClick={onNavigate}>
      <img src={logo} alt='MyTeacher.pro' className={styles.drawerLogo__image} />
      <div className={`${styles.drawerLogo__content} ${guest.logoContent}`}>
        <span className={`${styles.drawerLogo__title} ${guest.logoTitle}`}>MYTEACHER</span>
        <span className={`${styles.drawerLogo__badge} ${guest.badge}`}>PRO</span>
      </div>
    </a>
    <ul className={styles.navList}>
      {MARKETING_ITEMS.map(({ href, label, Icon }) => (
        <li key={label} className={styles.navItem}>
          <a href={href} className={styles.navLink} onClick={onNavigate}>
            <span className={guest.icon} aria-hidden='true'>
              <Icon size={18} strokeWidth={2} />
            </span>
            {label}
          </a>
        </li>
      ))}
    </ul>
    <div className={styles.navDivider} />
    <div className={guest.auth}>
      <NavLink
        to='/login'
        onClick={onNavigate}
        className={({ isActive }) => `${guest.authLink} ${isActive ? guest.authLinkActive : ''}`}
      >
        Вход
      </NavLink>
      <NavLink
        to='/registration'
        onClick={onNavigate}
        className={({ isActive }) => `${guest.authLink} ${isActive ? guest.authLinkActive : ''}`}
      >
        Регистрация
      </NavLink>
    </div>
  </>
);
